import { TableCell } from '@mui/material'

import { useTeamName } from '../../hooks/utils-functions'

const TableCellTeam = ({ id, stagione, bold }) => (
  <TableCell style={{ fontWeight: bold ? 'bold' : 'normal' }}>
    {useTeamName(id, stagione)}
  </TableCell>
)

export default TableCellTeam
